import { createDebugger } from '../../utils/debug';
import { parseCookies } from '../../utils/cookies';

const debug = createDebugger('monetate');

const MONETATE_ID_COOKIE_NAME = 'mt.v';

const MONETATE_EXPERIENCES_HEADER_NAME = 'x-experiences-json';

export const getExperiences = (headerValue) => {
  try {
    if (headerValue) {
      const decoded = Buffer.from(headerValue, 'base64').toString('utf8');
      return JSON.parse(decoded);
    }
  } catch (err) {
    debug(
      `Error decoding "${MONETATE_EXPERIENCES_HEADER_NAME}" header value: ${headerValue}`
    );
  }
  return [];
};

export const getExperiencesByContext = (context, pageType) => {
  if (!pageType) {
    throw new Error(`Missing pageType parameter in #getExperiencesByContext`);
  }

  const {
    req: { headers },
  } = context;

  const cookies = parseCookies(context);

  const experiences = getExperiences(headers[MONETATE_EXPERIENCES_HEADER_NAME]);

  const monetateId = cookies[MONETATE_ID_COOKIE_NAME] || null;

  return {
    experiences,
    monetateId,
    pageType,
  };
};
